export default function TextField(element) {
  const textField = element;

  textField.addEventListener("change", emptyField);

  function emptyField(event) {
    const inputField = event.target;
    const inputValue = inputField.value;

    if (inputValue !== "") {
      if (!inputField.classList.contains("is-filled")) {
        inputField.classList.add("is-filled");
      }
    } else if (inputField.classList.contains("is-filled")) {
      inputField.classList.remove("is-filled");
    }
  }
}
